export default __webpack_public_path__ + "static/anastasia-atanasova-d86bb9f53ccf38034f9d5f5f50671c75.jpg";